import React from 'react';
import { INSTAGRAM_LINK, SUPPORT_EMAIL, WHATSAPP_LINK } from './Shared';
export function Footer() {
  return <footer className="border-t border-brand-gold/40 bg-brand-greenDeep py-12 text-brand-cream" data-id="element-91" data-mp="3gfiswe27a3c0">
      <div className="mx-auto max-w-4xl px-4 text-center sm:px-6 lg:px-8" data-id="element-92" data-mp="32onjn0nshk7w">
        <div className="mb-8 rounded-2xl border border-white/10 bg-white/5 p-6 text-sm leading-relaxed" data-id="element-93" data-mp="36p6cmy1f4wbo">
          <p data-id="element-94" data-mp="3ufa6wespvjq0">
            <strong className="text-brand-goldLight" data-id="element-95" data-mp="3uesclnpm7fkq">P.D.:</strong> Si tienes dudas, escríbenos a{' '}
            <a className="font-semibold text-brand-amber hover:underline" href={`mailto:${SUPPORT_EMAIL}`} data-id="element-96" data-mp="38z6mkvj6mzq">
              {SUPPORT_EMAIL}
            </a>{' '}
            o por{' '}
            <a className="font-semibold text-brand-amber hover:underline" href={WHATSAPP_LINK} data-id="element-97" data-mp="3qcxbaj7op26y">
              WhatsApp
            </a>
            . También puedes encontrarnos en Instagram como{' '}
            <a className="font-semibold text-brand-amber hover:underline" href={INSTAGRAM_LINK} data-id="element-98" data-mp="2eyt7klbanzop">
              @lumen.akasha
            </a>
            . Te respondemos hoy.
          </p>
          <p className="mt-3 italic text-brand-cream/75" data-id="element-99" data-mp="3gapc1fucueee">
            El precio de lanzamiento sube pronto. El mejor momento para tener tu sistema profesional de Flores de Bach
            es ahora.
          </p>
        </div>

        <div className="mb-10 flex flex-col items-center justify-center gap-4 text-sm md:flex-row md:gap-7" data-id="element-100" data-mp="3q8dgwylod2aa">
          <a className="transition-colors duration-150 ease-out hover:text-brand-amber" href={`mailto:${SUPPORT_EMAIL}`} data-id="element-101" data-mp="81pghm1kl3ay">
            📧 {SUPPORT_EMAIL}
          </a>
          <a className="transition-colors duration-150 ease-out hover:text-brand-amber" href={INSTAGRAM_LINK} data-id="element-102" data-mp="hsk0ejrcfqt8">
            📲 @lumen.akasha
          </a>
          
        </div>

        <div className="mb-8" data-id="element-103" data-mp="cw36ta1dkk8r">
          <h3 className="mb-2 font-display text-3xl font-bold text-brand-goldLight" data-id="element-104" data-mp="qsqdi4j4qorv">🔮 LUMEN AKASHA™</h3>
          <p className="text-brand-cream/80" data-id="element-105" data-mp="msppbs68az7m">El sistema profesional para terapeutas en Flores de Bach Holística.</p>
          <p className="mt-2 text-brand-cream/70" data-id="element-106" data-mp="twfnps3h9trd">
            Porque trabajar con Flores de Bach con excelencia no debería costarte la seguridad ni la rentabilidad de tu
            consultorio.
          </p>
        </div>

        <div className="space-y-2 border-t border-white/10 pt-6 text-xs text-brand-cream/50" data-id="element-107" data-mp="13rzfq3ex88au">
          <p data-id="element-108" data-mp="18lbwjrdczat1">
            © Lumen Akasha™ 2025 — Todos los derechos reservados. Prohibida la reproducción y redistribución sin
            autorización expresa.
          </p>
          <p data-id="element-109" data-mp="1hje30mfv2vnp">
            Ley 25.326 — Protección de Datos Personales — República Argentina · Ley 11.723 — Propiedad Intelectual —
            República Argentina
          </p>
        </div>
      </div>
    </footer>;
}